import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IndividualBrandRoutingModule } from './individual-brand-routing.module';
import { MSkinConcernModal, MSkinTypeModal } from '../product/product.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    IndividualBrandRoutingModule
  ]
})
export class IndividualBrandModule { }

export class MGetSkinConcernResponse {
  "statusCode": number;
  "message": string;
  "totalRecords": number;
  "data": [MSkinConcernModal];
  "token": string;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class MGetSkinTypeResponse {
  "statusCode": number;
  "message": string;
  "totalRecords": number;
  "data": [MSkinTypeModal];
  "token": string;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

/**
 * Modal for SkinConcern Request
 */
export class MSkinConcernRequest {
  id!: any;
  category_id!: string;
  name!: string;
}
